// Social channels Aranor publishes on. Single source of truth — the
// footer "Follow us" row reads from here today; Phase 2 (Contact
// page) will reuse the same list so the channels stay in sync.
//
// Each entry's `Icon` is a component whose color comes from
// `currentColor`, so wrapping markup controls the tint via Tailwind
// `text-*` utilities.
import type React from 'react';
import {
  TripAdvisorIcon,
  TikTokIcon,
  InstagramIcon,
  LinkedinIcon,
  YoutubeIcon,
} from '../components/icons/SocialIcons';

export interface SocialChannel {
  label: string;
  url: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const SOCIALS: SocialChannel[] = [
  {
    label: 'TripAdvisor',
    url: 'https://www.tripadvisor.com/Attraction_Review-g293932-d34052988-Reviews-Aranor_Travel-Yerevan.html',
    Icon: TripAdvisorIcon,
  },
  {
    label: 'TikTok',
    url: 'https://www.tiktok.com/@aranor_travel',
    Icon: TikTokIcon,
  },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/aranor_travel/',
    Icon: InstagramIcon,
  },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/aranor-travel',
    Icon: LinkedinIcon,
  },
  {
    label: 'YouTube',
    url: 'https://www.youtube.com/@AranorTravel',
    Icon: YoutubeIcon,
  },
];
